import "./ProjectInvitesTable.css";

import { EyeBlueIcon } from "../../../assets";
import { ResultData } from "../../../service/Shared";
import { CursorDataGrid, DataGridColumnDefinition, DataGridIconCellFormatterData } from "../../data";
import { Button } from "../../forms";
import { ProjectInvitesTableProps } from "./models";

// The seven data columns take no width so they share the grid equally; View is pinned to roughly half
// of one of those shares. react-data-grid only parses integer percentages, so an exact half of a
// seven-way split (6.67%) is not expressible - 7% is the closest and holds at any viewport width.
const columns: DataGridColumnDefinition[] = [
  // Not filterable: organisation type is a GraphQL enum, which the grid's text filters cannot query.
  { key: "organisationType", name: "Organisation type", dataType: "string", filterable: false },
  { key: "inviteType", name: "Type", dataType: "string", filterable: false, sortable: false },
  { key: "organisationName", name: "Organisation", dataType: "string" },
  { key: "access", name: "Access", dataType: "string" },
  {
    key: "dateSent",
    name: "Date sent",
    dataType: "Date",
    formatter: "dateOnly",
    filterable: false,
  },
  { key: "createdBy", name: "Created by", dataType: "string" },
  {
    key: "status",
    name: "Status",
    dataType: "string",
    formatter: "projectAccessStatusPill",
    alignment: "left",
    filterable: false,
    sortable: false,
  },
  {
    key: "viewLink",
    name: "View",
    dataType: "string",
    formatter: "icon",
    alignment: "center",
    filterable: false,
    sortable: false,
  },
];

export const ProjectInvitesTable = ({
  rows,
  canCreateInvitation,
  onNewInvitation,
  onView,
  isLoading = false,
  onChange,
  variant = "default",
}: ProjectInvitesTableProps): JSX.Element => {
  const data: ResultData[] = rows.map((row) => ({
    uuid: row.invitationUuid,
    inviteType: row.inviteType ?? "",
    organisationType: row.organisationType,
    organisationName: row.organisationName,
    access: row.access,
    dateSent: new Date(row.dateSent),
    createdBy: row.createdBy,
    status: row.status,
    viewLink: {
      action: () => onView(row),
      icon: <EyeBlueIcon width={20} height={20} strokeWidth={1.5} />,
    } as DataGridIconCellFormatterData,
  }));

  const header = (
    <>
      <div className="ProjectInvitesTable_heading">
        <h2>Invites and requests</h2>
      </div>
      {canCreateInvitation && (
        <Button
          text="New invitation"
          size="small"
          corners={variant === "seed" ? "rounded" : "default"}
          onClick={onNewInvitation}
        />
      )}
    </>
  );

  return (
    <div className="ProjectInvitesTable">
      <CursorDataGrid
        columns={columns}
        data={data}
        header={header}
        clientSide={!onChange}
        onChange={onChange}
        sortable={!!onChange}
        filterable={!!onChange}
        pageable={!!onChange}
        showTotalCount={!!onChange}
        noDataMessage="No invitations or requests to display"
        dataIsLoading={isLoading}
        variant={variant}
      />
    </div>
  );
};
